import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../lib/auth.jsx";
import { useT } from "../lib/i18n.jsx";
import {
  IconMonitor, IconUsers, IconShield, IconSettings,
  IconLayers, IconActivity, IconCreditCard, IconArrow,
} from "./icons.jsx";

export default function AppShell() {
  const { user, logout } = useAuth();
  const { t, toggleLang } = useT();
  const role = user?.role;
  const isAdmin = role === "admin" || role === "superadmin";
  const isMod = role === "moderator" || isAdmin;

  return (
    <div className="shell">
      <aside className="shell-aside">
        <div className="brand">
          <div className="brand-mark">
            vorks<span className="dot" /><span className="con">connect</span>
          </div>
          <div className="brand-tag">control plane</div>
        </div>

        <nav className="shell-nav">
          <div className="nav-group-label">Workspace</div>
          <NavLink to="/devices" className="nav-link" data-label={t("nav_devices")}>
            <IconMonitor className="nav-icon" /> <span>{t("nav_devices")}</span>
          </NavLink>
          <NavLink to="/downloads" className="nav-link" data-label={t("nav_get_app")}>
            <IconArrow className="nav-icon" /> <span>{t("nav_get_app")}</span>
          </NavLink>
          <NavLink to="/device-code" className="nav-link" data-label={t("nav_pair_code")}>
            <IconShield className="nav-icon" /> <span>{t("nav_pair_code")}</span>
          </NavLink>
          <NavLink to="/billing" className="nav-link" data-label={t("nav_billing")}>
            <IconCreditCard className="nav-icon" /> <span>{t("nav_billing")}</span>
          </NavLink>
          <NavLink to="/account" className="nav-link" data-label="Account">
            <IconShield className="nav-icon" /> <span>Account</span>
          </NavLink>

          {isMod && (
            <>
              <div className="nav-group-label">Administration</div>
              <NavLink to="/admin/users" className="nav-link" data-label={t("nav_users")}>
                <IconUsers className="nav-icon" /> <span>{t("nav_users")}</span>
              </NavLink>
              <NavLink to="/admin/audit" className="nav-link" data-label={t("nav_audit")}>
                <IconActivity className="nav-icon" /> <span>{t("nav_audit")}</span>
              </NavLink>
            </>
          )}

          {isAdmin && (
            <>
              <NavLink to="/admin/devices" className="nav-link" data-label="Geräte verwalten">
                <IconMonitor className="nav-icon" /> <span>Geräte verwalten</span>
              </NavLink>
              <NavLink to="/admin/plans" className="nav-link" data-label={t("nav_plans")}>
                <IconLayers className="nav-icon" /> <span>{t("nav_plans")}</span>
              </NavLink>
              <NavLink to="/admin/subscriptions" className="nav-link" data-label={t("nav_subscriptions")}>
                <IconCreditCard className="nav-icon" /> <span>{t("nav_subscriptions")}</span>
              </NavLink>
              <NavLink to="/admin/releases" className="nav-link" data-label={t("nav_releases")}>
                <IconArrow className="nav-icon" /> <span>{t("nav_releases")}</span>
              </NavLink>
              <NavLink to="/admin/templates" className="nav-link" data-label={t("nav_templates")}>
                <IconSettings className="nav-icon" /> <span>{t("nav_templates")}</span>
              </NavLink>
              <NavLink to="/admin/browser-sessions" className="nav-link" data-label="Browser sessions">
                <IconActivity className="nav-icon" /> <span>Browser sessions</span>
              </NavLink>
              <NavLink to="/admin/settings" className="nav-link" data-label={t("nav_settings")}>
                <IconSettings className="nav-icon" /> <span>{t("nav_settings")}</span>
              </NavLink>
              <NavLink to="/admin/logs" className="nav-link" data-label="Logs">
                <IconActivity className="nav-icon" /> <span>Logs</span>
              </NavLink>
            </>
          )}
        </nav>

        <div className="shell-user">
          <div className="who">{user?.display_name}</div>
          <div className="email">{user?.email}</div>
          <span className="role-tag">
            <IconShield size={10} /> {t(`role_${role}`) || role}
          </span>
          <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
            <button className="signout" onClick={logout} style={{ flex: 1 }}>
              {t("nav_signout")}
            </button>
            <button
              className="signout"
              onClick={toggleLang}
              style={{ flex: 1, textAlign: "center" }}
              title="Switch language"
            >
              {t("lang_switch")}
            </button>
          </div>
        </div>
      </aside>

      <main className="shell-main">
        <Outlet />
      </main>
    </div>
  );
}
